import { ErrorTracking } from '../config';

export const safeStringify = (data) => {
  try {
    return JSON.stringify(data);
  } catch (e) {
    ErrorTracking.error('Unable to stringify data (safeStringify)', e, {
      dataType: typeof data,
    });
    return null;
  }
};

export const safeParseJson = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};
